import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FpFooterComponent } from "../common/fp-footer/fp-footer.component";
import { FpNavbarComponent } from "../common/fp-navbar/fp-navbar.component";
import { AppEnvironmentService } from '../../../../ui-framework/global-services/app-environment.service';

@Component({
  selector: 'app-contact-us',
  imports: [FpFooterComponent, FpNavbarComponent, RouterLink],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactUsComponent {
  constructor(private readonly appEnvironmentService: AppEnvironmentService) {}

  get homeRoute(): string {
    return this.appEnvironmentService.isLoggedIn ? '/dashboard' : '/authentication';
  }
}
